import { EDocumentType, UUID } from '@okcargo-apps/shared-domain';
export interface ICompanyDocument {
  id: UUID;
  type: EDocumentType;
  name?: string;
  description?: string;
  contentType?: string;
  createdAt?: Date;
  aggregateId?: UUID;
  freightStopId?: UUID;
  companyId?: number;
  path?: string;
  expiresOn?: Date;

  url?: string;
}

// TODO move to an specific feature `invoice`

export interface IInvoice {
  id: UUID;
  name: string;
  date: Date;
  dateDue: Date;
  amountTotal: number;
  amountTax: number;
  amountUntaxed: number;
  state: EInvoiceState;
  documentId: UUID;
}

// TODO remove this, use EInvoiceStatus??
export enum EInvoiceState {
  NOT_PAID = 'NOT_PAID',
  IN_PAYMENT = 'IN_PAYMENT',
  PAID = 'PAID',
  DRAFT = 'DRAFT',
  GENERATED = 'GENERATED',
}

export enum EInvoiceType {
  PURCHASE = 'PURCHASE',
  SALE = 'SALE',
}
